module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "ordercontainer",
    staticClass: "order-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "left"
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCol
    }
  }, [_vm._v("设置显示列")]), _vm._v(" "), (_vm.loginRole !== 2) ? _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出订单")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportDetailExcelByPageNum
    }
  }, [_vm._v("导出明细")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "placeholder": "按区域搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.sortAreaId),
      callback: function($$v) {
        _vm.sortAreaId = $$v
      },
      expression: "sortAreaId"
    }
  }, _vm._l((_vm.allAreaDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "left"
    }
  }, [(_vm.loginRole === 1) ? _c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按培训公司搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.aagencyid),
      callback: function($$v) {
        _vm.aagencyid = $$v
      },
      expression: "aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按订单状态搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.paystatus),
      callback: function($$v) {
        _vm.paystatus = $$v
      },
      expression: "paystatus"
    }
  }, _vm._l((_vm.orderStatusOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": "订单日期起",
      "picker-options": _vm.startPickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.orderTimeChange('start')
      }
    },
    model: {
      value: (_vm.orderStartime),
      callback: function($$v) {
        _vm.orderStartime = $$v
      },
      expression: "orderStartime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": "订单日期止",
      "picker-options": _vm.endPickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.orderTimeChange('end')
      }
    },
    model: {
      value: (_vm.orderEndtime),
      callback: function($$v) {
        _vm.orderEndtime = $$v
      },
      expression: "orderEndtime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "right"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索字段"
    },
    on: {
      "change": _vm.searchColumn
    },
    model: {
      value: (_vm.fuzzyField),
      callback: function($$v) {
        _vm.fuzzyField = $$v
      },
      expression: "fuzzyField"
    }
  }, _vm._l((_vm.fuzzyFieldOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "ceter"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索内容"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.vague),
      callback: function($$v) {
        _vm.vague = $$v
      },
      expression: "vague"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.colUnShowKeys.indexOf('code') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "code",
      "label": "订单单号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('creatdate') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "creattime1",
      "label": " 订单日期 ",
      "formatter": _vm.formatCreatdate,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('creattime') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "creattime2",
      "label": "订单时间",
      "formatter": _vm.formatCreattime,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('ordercaretername') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "ordercaretername",
      "label": "下单人",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('aagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "aagencyname",
      "label": "培训公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('pagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "pagencyname",
      "label": "销售公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('cagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "cagencyname",
      "label": "代理1",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('tagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "tagencyname",
      "label": "代理2",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('consignee') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "consignee",
      "label": "收货人",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('linkphone') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "linkphone",
      "label": "收货电话",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('province') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('city') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('district') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "district",
      "label": "县（区）",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('promotiontitle') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "promotiontitle",
      "label": "促销标题",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('totalamount') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "totalamount",
      "label": "实际总金额",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('voucherid') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "voucherid",
      "label": "返单券ID",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('voucheramount') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "voucheramount",
      "label": "返单券金额",
      "formatter": _vm.formatVoucherAmount,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('paystatus') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "paystatus",
      "label": "订单状态",
      "formatter": _vm.formatPaystatus,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('u8id') === -1) ? _c('af-table-column', {
    attrs: {
      "label": "U8ID",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.paystatus === '-3') ? _c('label', {
          staticStyle: {
            "text-decoration": "underline",
            "color": "#d0326c",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.checkU8idPayfailreason(scope.$index, scope.row)
            }
          }
        }, [_vm._v("同步失败！")]) : _vm._e(), _vm._v(" "), (scope.row.paystatus !== '-3') ? _c('label', [_vm._v(_vm._s(scope.row.u8id))]) : _vm._e()]
      }
    }], null, false, 910277675)
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('franchisee') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "franchisee",
      "label": "加盟商姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('finaladdress') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "finaladdress",
      "label": "收货地址",
      "align": "left"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('remark') === -1) ? _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "150"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('isreported') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "isreported",
      "label": "是否报备",
      "formatter": _vm.formatIsreported,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('storename') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "storename",
      "label": "店铺名称",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('notreportreason') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "notreportreason",
      "label": "未报备原因",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('ordertype') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "ordertype",
      "label": "订单类型",
      "formatter": _vm.formatOrderType,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('af-table-column', {
    key: Math.random(),
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "130",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.currentOpDataList.indexOf(scope.row.code) >= 0),
            expression: "currentOpDataList.indexOf(scope.row.code) >= 0"
          }],
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.nextStep(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v("|\n\t\t\t\t\t"), _c('el-dropdown', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.currentOpDataList.indexOf(scope.row.code) >= 0),
            expression: "currentOpDataList.indexOf(scope.row.code) >= 0"
          }],
          staticStyle: {
            "line-height": "0"
          },
          attrs: {
            "trigger": "hover"
          }
        }, [_c('label', {
          staticClass: "edit-content edit-more"
        }, [_vm._v("更多")]), _vm._v(" "), _c('el-dropdown-menu', {
          staticClass: "edit-more-content",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(scope.row.paystatus === '0' || !scope.row.paystatus || (_vm.loginRole === 1 && scope.row.paystatus === '-3')) ? _c('el-dropdown-item', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editPaystatusData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("付款")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (_vm.loginRole === 1 || scope.row.paystatus === '0') ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": "设置显示列",
      "visible": _vm.colDialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.colDialogVisible = $event
      },
      "close": _vm.closeColSet
    }
  }, [_c('el-transfer', {
    staticStyle: {
      "width": "500px",
      "margin": "15px auto"
    },
    attrs: {
      "data": _vm.colDatas,
      "titles": ['显示列', '不显示列']
    },
    model: {
      value: (_vm.colUnShowKeys),
      callback: function($$v) {
        _vm.colUnShowKeys = $$v
      },
      expression: "colUnShowKeys"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单日期",
      "prop": "creattime"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.creattime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "creattime", $$v)
      },
      expression: "formData.creattime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单人",
      "prop": "ordercaretername"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.ordercaretername),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercaretername", $$v)
      },
      expression: "formData.ordercaretername"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "培训公司",
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.aagencyid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aagencyid", $$v)
      },
      expression: "formData.aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售公司",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.pagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pagencyname", $$v)
      },
      expression: "formData.pagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理1",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.cagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cagencyname", $$v)
      },
      expression: "formData.cagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理2",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.tagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tagencyname", $$v)
      },
      expression: "formData.tagencyname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人",
      "prop": "consignee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consignee", $$v)
      },
      expression: "formData.consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货电话",
      "prop": "linkphone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.linkphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "linkphone", $$v)
      },
      expression: "formData.linkphone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市县(区)",
      "prop": "province"
    }
  }, [_c('region-picker', {
    attrs: {
      "placeholder": {
        province: '选择省份',
        city: '选择市',
        district: '选择县（区）'
      },
      "province": _vm.formData.region.province,
      "city": _vm.formData.region.city,
      "district": _vm.formData.region.district
    },
    on: {
      "onchange": _vm.regionChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加盟商姓名",
      "prop": "franchisee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.franchisee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "franchisee", $$v)
      },
      expression: "formData.franchisee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否报备",
      "prop": "isreported"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.isreported),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isreported", $$v)
      },
      expression: "formData.isreported"
    }
  }, _vm._l((_vm.isreportedOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "storename"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.storename),
      callback: function($$v) {
        _vm.$set(_vm.formData, "storename", $$v)
      },
      expression: "formData.storename"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "未报备原因",
      "prop": "notreportreason"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "maxlength": "18"
    },
    model: {
      value: (_vm.formData.notreportreason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "notreportreason", $$v)
      },
      expression: "formData.notreportreason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "ordertype"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.editDisabled
    },
    on: {
      "change": _vm.ordertypeChange
    },
    model: {
      value: (_vm.formData.ordertype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordertype", $$v)
      },
      expression: "formData.ordertype"
    }
  }, _vm._l((_vm.orderTypeOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "促销标题",
      "prop": "promotiontitle"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.promotiontitleDisabled
    },
    model: {
      value: (_vm.formData.promotiontitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "promotiontitle", $$v)
      },
      expression: "formData.promotiontitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际总金额",
      "prop": "totalamount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.editDisabled
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.cash.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.formData.totalamount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "totalamount", $$v)
      },
      expression: "formData.totalamount"
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.paystatus === '0') ? _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单状态",
      "prop": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickPaystatus
    }
  }, [_vm._v("付款")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '查看物流',
      "visible": _vm.logisticsDialogVisible,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logisticsDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.logisticsDatas,
      "stripe": true,
      "height": 400,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('af-table-column', {
    attrs: {
      "prop": "name",
      "label": "订单单号",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "code",
      "label": "下单时间",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "type",
      "label": "下单人",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "unit",
      "label": "物流信息",
      "align": "center",
      "min-width": "40%"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '导出订单明细进度',
      "visible": _vm.progressDialogVisible,
      "width": "700px",
      "before-close": _vm.beforeCloseProgressDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.progressDialogVisible = $event
      },
      "opened": _vm.openProgressDialog
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-progress', {
    staticStyle: {
      "margin": "15px 20px"
    },
    attrs: {
      "text-inside": true,
      "stroke-width": 24,
      "percentage": _vm.progressPercentage,
      "status": "success"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('span', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "font-size": "35px",
      "line-height": "65px"
    },
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '同步U8ID失败原因',
      "visible": _vm.u8idDialogVisible,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.u8idDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "200px",
      "margin": "30px",
      "color": "red",
      "font-size": "20px",
      "line-height": "30px"
    }
  }, [_vm._v(_vm._s(_vm.u8idPayfailreason))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-156588c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/orderManagement/Order.vue
// module id = 699
// module chunks = 1